<template>
  <div>
    <div class="d-none d-print-block">
      <div
        :id="lv1_info?.name + '_' + lv2_info?.name"
        class="sb-cover-wrapper in-view"
        :class="{ 'in-view': inView }"
        :style="backgroundStyle"
      >
        <!-- 상단 영역 -->
        <div class="sb-cover-top skinc-container">
          <!-- 상단 상단 -->
          <div class="sb-cover-top-header">
            <h5 class="skinc-red-text">{{ lv1_info?.name }}</h5>
          </div>
          <!-- 상단 하단 -->
          <h2 class="sb-cover-top-title gray-900">
            {{ lang === 'KOR' ? lv2_info?.name : lv2_info?.name_em || lv2_info?.name_ea }}
          </h2>
        </div>
        <!-- 중단 영역 -->
        <div class="sb-cover-middle" :style="middleBackgroundStyle">
          <img
            v-if="lv1_info?.cover_path || lv1_info?.cover_unsplash_path"
            :src="middleImageUrl"
            alt="cover image"
          />
        </div>
        <!-- 하단 영역 -->
        <div class="sb-cover-bottom skinc-container">
          <div class="left-content" v-html="displayDisclosureText"></div>
          <div class="right-content">
            <img src="/static_img/skinc/sub_pages/quote.png" alt="static" />
          </div>
        </div>
      </div>
    </div>

    <div ref="coverRoot" class="d-block d-print-none">
      <div
        :id="lv1_info?.name + '_' + lv2_info?.name"
        class="sb-cover-wrapper"
        :class="{ 'in-view': inView }"
        :style="backgroundStyle"
      >
        <!-- 상단 영역 -->
        <div class="sb-cover-top skinc-container">
          <!-- 상단 상단 -->
          <div class="sb-cover-top-header">
            <h5 class="skinc-red-text">{{ lv1_info?.name }}</h5>
            <div class="skinc-breadcrumb fw-600">
              <span class="gray-600">Home</span>
              <span class="gray-400 mx-3">
                <svg
                  width="6"
                  height="12"
                  viewBox="0 0 4 8"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M0 8L4 4L0 0" fill="#B8B8B8" />
                </svg>
              </span>
              <span class="gray-600">
                {{ lang === 'KOR' ? lv1_info?.name : lv1_info?.name_em || lv1_info?.name_ea }}
              </span>
              <span class="gray-400 mx-3">
                <svg
                  width="6"
                  height="12"
                  viewBox="0 0 4 8"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M0 8L4 4L0 0" fill="#B8B8B8" />
                </svg>
              </span>
              <span class="gray-900">
                {{ lang === 'KOR' ? lv2_info?.name : lv2_info?.name_em || lv2_info?.name_ea }}
              </span>
            </div>
          </div>
          <!-- 상단 하단 -->
          <h2 class="sb-cover-top-title gray-900">
            {{ lang === 'KOR' ? lv2_info?.name : lv2_info?.name_em || lv2_info?.name_ea }}
          </h2>
        </div>
        <!-- 중단 영역 -->
        <div class="sb-cover-middle" :style="middleBackgroundStyle">
          <img
            v-if="lv1_info?.cover_path || lv1_info?.cover_unsplash_path"
            :src="middleImageUrl"
            alt="cover image"
          />
        </div>
        <!-- 하단 영역 -->
        <div class="sb-cover-bottom skinc-container">
          <div class="left-content" v-html="displayDisclosureText"></div>
          <div class="right-content">
            <img src="/static_img/skinc/sub_pages/quote.png" alt="static" />
          </div>
        </div>
      </div>
    </div>
    <!-- <pre>
    {{ disclosures }}
    </pre> -->
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'Cover',
  props: {
    lv1_info: { type: Object, default: () => ({}) },
    lv2_info: { type: Object, default: () => ({}) },
    disclosures: { type: Array, default: () => [] }
  },
  data() {
    return {
      inView: true,
      defaultImageUrl: 'https://sustainability.skecoplant.com/_nuxt/img/governace.fe5ba35.jpg',
      imageMappings: [
        {
          imagekey: 'bnjxa250324_491c34c94efb',
          imagesrc: '/static_img/skinc/cover/기후변화대응.webp'
        },
        {
          imagekey: 'bnjxa250324_512c35c37643',
          imagesrc: '/static_img/skinc/cover/환경영향관리.webp'
        },
        { imagekey: 'bnjxa250324_827756452769', imagesrc: '/static_img/skinc/cover/인권경영.webp' },
        { imagekey: 'bnjxa250324_0a5aea89e9ac', imagesrc: '/static_img/skinc/cover/인재경영.webp' },
        {
          imagekey: 'bnjxa250324_aae82f63b8c1',
          imagesrc: '/static_img/skinc/cover/안전및보건.webp'
        },
        {
          imagekey: 'bnjxa250324_2c7c3956b119',
          imagesrc: '/static_img/skinc/cover/공급망관리.webp'
        },
        { imagekey: 'bnjxa250324_278661629840', imagesrc: '/static_img/skinc/cover/정보보안.webp' },
        {
          imagekey: 'bnjxa250324_38682ed9cf93',
          imagesrc: '/static_img/skinc/cover/서비스품질및안정성.webp'
        },
        { imagekey: 'bnjxa250324_ad7afb098cdd', imagesrc: '/static_img/skinc/cover/사회공헌.webp' },
        { imagekey: 'bnjxa250324_ea5da1b92007', imagesrc: '/static_img/skinc/cover/지배구조.webp' },
        {
          imagekey: 'bnjxa250324_76c8077e0269',
          imagesrc: '/static_img/skinc/cover/윤리및컴플라이언스.webp'
        },
        {
          imagekey: 'bnjxa250324_d72a23cf71e5',
          imagesrc: '/static_img/skinc/cover/리스크및기회관리.webp'
        },
        { imagekey: 'bnjxa250324_d1af48b529ba', imagesrc: '/static_img/skinc/cover/ESGData.webp' }
      ]
    };
  },
  computed: {
    ...mapState('report_list', ['lang']),
    backgroundStyle() {
      return { backgroundColor: '#fff' };
    },
    middleImageUrl() {
      // 1) lv2_info.key 매핑된 이미지가 있으면 우선 반환
      const mapping = this.imageMappings.find(m => m.imagekey === this.lv2_info?.key);
      if (mapping) {
        return mapping.imagesrc;
      }

      // 2) 기존 lv1_info.cover 경로 처리 로직
      if (this.lv1_info?.cover_path) {
        return this.$store.state.static_host + this.lv1_info.cover_path.replaceAll('\\', '/');
      } else if (this.lv1_info?.cover_unsplash_path) {
        return this.lv1_info.cover_unsplash_path;
      }
      // 3) 기본 이미지
      return this.defaultImageUrl;
    },
    middleBackgroundStyle() {
      if (this.lv1_info?.cover_path || this.lv1_info?.cover_unsplash_path) {
        return {};
      }
      return {
        backgroundColor: this.lv1_info?.background_color || '#f5f5f5',
        height: '360px'
      };
    },
    // [수정된 부분]
    displayDisclosureText() {
      if (!this.disclosures?.length) return '';

      const first = this.disclosures[0];
      // 표시할 disclosure 객체를 먼저 결정합니다.
      const targetDisclosure =
        first?.guide_mode && this.disclosures.length > 1 ? this.disclosures[1] : first;

      if (!targetDisclosure) return '';

      // lang 값에 따라 적절한 텍스트를 반환합니다.
      if (this.lang === 'ENG') {
        // 영문 텍스트(text_e)가 있으면 그것을, 없으면 국문 텍스트(text)를, 둘 다 없으면 빈 문자열을 반환합니다.
        return targetDisclosure.text_ea || targetDisclosure.text_em || targetDisclosure.text || '';
      }
      // 기본적으로 국문 텍스트를 반환합니다.
      return targetDisclosure.text || '';
    }
  }
};
</script>

<style lang="scss" scoped>
.sb-cover-wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 84px;
  border-bottom: 1px solid #dddddd;

  .sb-cover-top {
    padding-top: 3rem;
    padding-bottom: 2rem;
    display: flex;
    flex-direction: column;

    .sb-cover-top-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 0.5rem;

      .skinc-breadcrumb {
        font-size: 1rem;
      }
    }

    .sb-cover-top-title {
      font-size: clamp(36px, 5vw, 72px);
      line-height: 1.3;
      font-weight: 600;
      word-break: keep-all;
    }
  }

  .sb-cover-middle {
    max-height: 360px;

    img {
      width: 100%;
      height: auto;
      max-height: 360px;
      object-fit: cover;
    }
  }

  .sb-cover-bottom {
    display: flex;
    padding-top: 3rem;
    padding-bottom: 2rem;

    .left-content {
      flex: 0 0 90%;
      font-size: clamp(1rem, 2vw, 1.2rem);
      font-weight: 400;
      color: #121212;
      opacity: 0;
      transform: translateX(-20px);
    }

    .right-content {
      flex: 0 0 10%;
      display: flex;
      justify-content: flex-end;
      align-items: flex-start;

      img {
        max-width: 100px;
        height: auto;
      }
    }
  }
}

@keyframes floatUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateX(-20px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.sb-cover-top {
  opacity: 0;
  transform: translateY(20px);
}

.sb-cover-wrapper.in-view .sb-cover-top {
  animation: floatUp 0.6s ease-out forwards;
}

.sb-cover-wrapper.in-view .sb-cover-bottom .left-content {
  animation: slideIn 1s ease-out 0.6s forwards;
}

@media print {
  .sb-cover-wrapper.in-view .sb-cover-top,
  .sb-cover-wrapper.in-view .sb-cover-bottom .left-content {
    animation: none !important;
    opacity: 1 !important;
    transform: none !important;
  }

  .sb-cover-wrapper {
    height: 90vh !important;
    border-bottom: none;
  }
  .sb-cover-middle {
    height: 1080px !important;
    img {
      width: 100%;
      height: 1080px !important;
      object-fit: cover;
    }
  }
}

/* --- 반응형 및 인쇄 스타일 --- */

/* [요청 2] 화면 너비가 992px 이하일 때 적용될 스타일 (태블릿, 모바일) */
@media screen and (max-width: 992px) {
  .sb-cover-wrapper .sb-cover-top {
    padding-top: 2rem;
    padding-bottom: 1.5rem;
  }

  /* 상단 헤더 영역 세로 배치 */
  .sb-cover-wrapper .sb-cover-top .sb-cover-top-header {
    flex-direction: column; /* 세로 방향으로 변경 */
    align-items: flex-start; /* 왼쪽 정렬 */
    gap: 0.75rem; /* 아이템 사이의 간격 추가 */
  }

  .sb-cover-wrapper .sb-cover-top .sb-cover-top-title {
    margin-top: 1rem;
  }
}

/* 화면 너비가 576px 이하일 때 추가 적용될 스타일 (모바일) */
@media screen and (max-width: 576px) {
  .sb-cover-wrapper .sb-cover-top .sb-cover-top-header .skinc-breadcrumb {
    font-size: 0.875rem; /* 브레드크럼브 폰트 크기 살짝 줄임 */
  }

  .sb-cover-wrapper .sb-cover-bottom {
    flex-direction: column; /* 하단 콘텐츠도 세로로 배치 */
    gap: 2rem;

    .left-content,
    .right-content {
      flex: 1 1 100%; /* 너비 100%로 설정 */
    }
    .right-content {
      justify-content: flex-start; /* 인용부호 아이콘 왼쪽으로 정렬 */
    }
  }
}
</style>
